import template from './select-amount.html';
import angular from 'angular';
import './select-amount.scss';
class PaymentSelectAmountController {
    /*@ngInject*/
    constructor($injector) {
        this.$injector = $injector;
        this.currencyService = $injector.get('currencyService');
    }
    $onInit() {
        this.currencies = this.currencyService.getCurrenciesArray();
    }
    toggleDropdown() {
        this.isShownDropdown = !this.isShownDropdown;
    }
    selectCurrency(currency) {
        this.currency = currency;
        this.toggleDropdown();
    }
    submit() {
        if (!this.amount)
            return;
        this.onSubmit({
            amount: Math.round(this.amount * 100),
            currency: this.currency,
        });
    }
    cancel() {
        this.onCancel();
    }
    getCountryCode(currencyCode) {
        return currencyCode.substring(0, 2).toLowerCase();
    }
}
class PaymentSelectAmountComponent {
    constructor() {
        this.controller = PaymentSelectAmountController;
        this.template = template;
        this.bindings = {
            onSubmit: '&',
            onCancel: '&',
            target: '<',
            currency: '<',
        };
    }
}
export default angular
    .module('doxy.realtime.components.doctor-payment.action.pay.paymentSelectAmount', [])
    .component('paymentSelectAmount', new PaymentSelectAmountComponent()).name;
